import axios from "axios";
import { HideAwaiting, ShowAwaiting } from "../util/Awaiting";
import { authenticatedHeader } from "./DefaultConfig";

export async function authenticatedGetAPI(url: string) {
  ShowAwaiting();
  var res = await axios.get(url, authenticatedHeader());
  HideAwaiting();
  return res.data;
}

export async function authenticatedPostAPI(url: string, data: any) {
  ShowAwaiting();
  var res = await axios.post(url, data, authenticatedHeader());
  HideAwaiting();
  return res.data;
}
